import { useRef } from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Button } from "../ui/button";
import { printRef } from "../../lib/print";

export default function PhoneListTab({ students }) {
  const phoneListRef = useRef(null);
  const sorted = [...students].sort((a, b) => a.last_name.localeCompare(b.last_name));

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div><CardTitle>Quick Phone List</CardTitle><CardDescription>Student names and parent/guardian phone numbers for quick reference</CardDescription></div>
          <Button onClick={() => printRef("Quick Phone List", phoneListRef)} className="bg-[#00305E] hover:bg-[#00305E]/90" data-testid="print-phone-list-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
            Print Phone List
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div ref={phoneListRef}>
          <table className="w-full border-collapse" data-testid="phone-list-table">
            <thead><tr className="bg-gray-50 border-b-2 border-gray-200"><th className="text-left py-3 px-4 font-semibold text-sm text-[#00305E]">#</th><th className="text-left py-3 px-4 font-semibold text-sm text-[#00305E]">Student Name</th><th className="text-left py-3 px-4 font-semibold text-sm text-[#00305E]">Contact 1</th><th className="text-left py-3 px-4 font-semibold text-sm text-[#00305E]">Phone 1</th><th className="text-left py-3 px-4 font-semibold text-sm text-[#00305E]">Contact 2</th><th className="text-left py-3 px-4 font-semibold text-sm text-[#00305E]">Phone 2</th></tr></thead>
            <tbody>
              {sorted.map((student, idx) => (
                <tr key={student.id} className={`border-b ${idx % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`} data-testid={`phone-list-row-${student.id}`}>
                  <td className="py-2.5 px-4 text-sm text-gray-500">{idx + 1}</td>
                  <td className="py-2.5 px-4 text-sm font-medium">{student.last_name}, {student.first_name}</td>
                  <td className="py-2.5 px-4 text-sm text-gray-600">{student.first_contact_name || <span className="text-gray-300 italic">—</span>}{student.first_contact_relationship && <span className="text-xs text-gray-400 ml-1">({student.first_contact_relationship})</span>}</td>
                  <td className="py-2.5 px-4 text-sm font-mono">{student.first_contact_phone || <span className="text-gray-300 italic">—</span>}</td>
                  <td className="py-2.5 px-4 text-sm text-gray-600">{student.second_contact_name || <span className="text-gray-300 italic">—</span>}{student.second_contact_relationship && <span className="text-xs text-gray-400 ml-1">({student.second_contact_relationship})</span>}</td>
                  <td className="py-2.5 px-4 text-sm font-mono">{student.second_contact_phone || <span className="text-gray-300 italic">—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {students.length === 0 && <p className="text-center py-8 text-muted-foreground">No current students found</p>}
          <p className="text-xs text-gray-400 mt-4 text-right">{students.length} student{students.length !== 1 ? 's' : ''}</p>
        </div>
      </CardContent>
    </Card>
  );
}
